import Home from '../../pages/Home/Home'
import Login from '../../pages/Login/Login'
import ForgotPassword from '../../pages/ForgotPassword/ForgotPassword'
import Settings from '../../pages/Settings/Settings'
import SettingsMobileMenu from '../../pages/Settings/SettingsMobileMenu'
import Query from '../../pages/Query/Query'

export const routes = [
  {
    key: 'login',
    path: '/login',
    exact: true,
    authNeeded: false,
    element: <Login />,
  },
  {
    key: 'reset-password',
    path: '/reset-password',
    exact: true,
    authNeeded: false,
    element: <ForgotPassword />,
  },
  {
    key: 'home',
    path: '/home',
    exact: true,
    authNeeded: false,
    element: <Home />,
  },
  {
    key: 'settings',
    path: '/settings',
    exact: true,
    authNeeded: false,
    element: <Settings />,
  },
  {
    key: 'settings-menu',
    path: '/settings-menu',
    exact: true,
    authNeeded: false,
    element: <SettingsMobileMenu />,
  },
  {
    key: 'help',
    path: '/help',
    exact: true,
    authNeeded: false,
    element: <Query />,
  },
]
